export const $ = function (str) {
  const div = document.createElement('div')
  div.innerHTML = str
  return div.children[0]
}

export const addEvent = function (el, type, func) {
  return el.addEventListener(type, func, { passive: false });
};

export const removeEvent = function (el, type, func) {
  return el.removeEventListener(type, func);
};
